/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    global: {
        'html, body': {
            backgroundColor: 'stokkeCore.white',
            color: 'stokkeCore.black'
        },
        body: {
            minHeight: '100vh'
        },
        '.react-target': {
            display: 'flex',
            minHeight: '100vh'
        },
        'b, strong': {
            fontFamily: 'stokkeSemiBold',
            fontWeight: 'semibold'
        },
        // Bottom toast message has larger margins
        // to be moved to toast.js when that can access parent toast list item
        '.chakra-toast:last-of-type': {
            mb: {
                base: 2,
                lg: 4,
                xl: 6
            }
        },
        '.sr-only': {
            position: 'absolute',
            width: '1px',
            height: '1px',
            padding: 0,
            margin: '-1px',
            overflow: 'hidden',
            clip: 'rect(0,0,0,0)',
            border: 0
        },
        'pwa-widget-add-to-cart': {
            display: 'block',
            // This is a hack to mimic SG - always take 400px width on desktop
            width: {lg: '25rem'}
        },
        // Remove overflow hidden from accordion collapse component, because of Spare Parts recommendations slider arrows
        // Chakra set the property directly in the element styling and if we want to change that prop with class selector we need to add an additional !important
        '.chakra-collapse': {
            overflow: 'visible!important'
        },
        // hide content in cms that is not supported in pwa
        '.cms-page-module .pwa-not-supported': {
            display: 'none !important'
        },
        // hide default browser 'X' that clears the input icons from search type inputs
        'input[type="search"]::-webkit-search-cancel-button, input[type="search"]::-webkit-search-decoration, input[type="search"]::-webkit-search-results-button, input[type="search"]::-webkit-search-results-decoration':
            {
                display: 'none'
            },
        ':focus-visible': {
            boxShadow: 'none !important',
            outlineStyle: 'solid !important',
            outlineWidth: '3px !important',
            outlineOffset: '2px !important',
            outlineColor: 'stokkeBeige.accessibleText !important'
        },
        // toast position overrides as chakra doesn't allow to modify this in code
        '#chakra-toast-manager-top-left, #chakra-toast-manager-top, #chakra-toast-manager-top-right':
            {
                left: 'env(save-area-inset-left, 0px)',
                right: 'env(save-area-inset-right, 0px)',
                maxWidth: 'container.xxl',
                marginX: 'auto',
                // extend end-to-end on mobile
                alignItems: 'stretch',
                // override toast top offset to position bellow header and any subnavigation
                top:
                    'max(' +
                    // this is the default value and it's good to have it as a fallback
                    '  env(safe-area-inset-top, 0px),' +
                    '  calc(' +
                    // header height
                    '    var(--header-height, 0px) +' +
                    // subnavigation height
                    '    var(--subnavigation-height, 0px) +' +
                    // add 40px when subnavigation is visible - use clamp and round to emulate if statement
                    '    round(' +
                    '      clamp(0px, var(--subnavigation-height, 0px), 1px),' +
                    '      1px' +
                    '    ) * 40' +
                    '  )' +
                    ')' +
                    // needed to override the inline style
                    '!important',
                // matches header transition and makes for a smoother behavior when scrolling
                transition: 'top 0.5s;'
            },
        // reset extend end-to-end on desktop
        '#chakra-toast-manager-top-left': {
            alignItems: {lg: 'flex-start'}
        },
        '#chakra-toast-manager-top': {
            alignItems: {lg: 'center'}
        },
        '#chakra-toast-manager-top-right': {
            alignItems: {lg: 'flex-end'}
        }
    }
}
